function PageTitle({ children, textSizeClass, alignment = 'default' }) {
    const alignmentClass = alignment === 'left' ? 'sm:justify-start md:justify-start' : 'sm:justify-center md:justify-between';

    return (
        <div className={`comp__pageTitle min-w-0 sm:flex ${alignmentClass} sm:items-center`}>
            <h1 className={`${textSizeClass ? textSizeClass : "text-2xl md:text-3xl"} min-w-0 flex-wrap text-gray-800 dark:text-slate-100 font-bold flex gap-2 items-center`}>
                {children}
            </h1>
        </div>
    );
}

export default PageTitle;
